<template>
  <div id="app">
    <div
      class="content drop-shadow"
      :class="{ 'error-view': routeIsError }"
    >
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const routeIsError = computed(() => (route.name === 'ErrorPage'));
</script>

<style lang="scss">
#app {
  flex: 1;
  width: 100%;
  @include font-primary();
  @include font-primary-weight-regular();
  color: $color-black;
}
@media only screen and (max-width: $breakpoint) {
  .drop-shadow {
    display: none;
  }
}
@media only screen and (min-width: $breakpoint) {
  .drop-shadow {
    display: block;
    border-radius: 3px;
    box-shadow: 0 1px 1px 0 rgba(60, 64, 67, 0.08), 0 1px 3px 1px rgba(60, 64, 67, 0.16);
    box-sizing: border-box;
    transition-property: box-shadow, width;
    transition-duration: 135ms, 235ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    min-height: 0;

    &:not(&__disable-hover):hover {
      box-shadow: 0 1px 3px 1px rgba(60, 64, 67, 0.2), 0 2px 8px 4px rgba(60, 64, 67, 0.1);
    }
  }
}

.content {
  display: flex;
  flex-direction: column;
  max-width: $breakpoint;
  margin: 0 auto;
  padding: 0 24px 50px 24px;
  margin-top: 96px;

  @media only screen and (max-width: $breakpoint) {
    padding: 0 16px 50px 16px;
    margin-top: 0;
  }

  &__heading {
    text-transform: uppercase;
  }
}

.error-view {
  max-width: 100%;
  padding: 0;
  height: 100%;
}
</style>
